<section class="ticket-page">
  <div class="ticket-toolbar">
    <a class="back-link" routerLink="/dashboard/search">
      <i class="material-icons">arrow_back</i>
      Find trips
    </a>
    <div class="toolbar-actions" *ngIf="ticket && !isLoading">
      <button class="secondary-action" type="button" (click)="printTicket()">
        <i class="material-icons">print</i>
        Print
      </button>
      <button class="primary-action" type="button" (click)="downloadTicketPdf()">
        <i class="material-icons">download</i>
        Download PDF
      </button>
      <a class="wallet-action" *ngIf="getWalletPassUrl()" [href]="getWalletPassUrl()" (click)="openWalletPass($event)" rel="noopener">
        <i class="material-icons">account_balance_wallet</i>
        {{ isOpeningWalletPass ? 'Opening Wallet...' : 'Add to Apple Wallet' }}
      </a>
    </div>
  </div>

  <div class="ticket-shell">
    <div class="loading-state" *ngIf="isLoading">
      <i class="material-icons">sync</i>
      <span>Loading e-ticket...</span>
    </div>

    <div class="alert error" *ngIf="error">
      <i class="material-icons">error</i>
      <span>{{ error }}</span>
    </div>

    <div class="alert error" *ngIf="walletError">
      <i class="material-icons">error</i>
      <span>{{ walletError }}</span>
    </div>

    <article class="ticket" *ngIf="ticket && !isLoading" id="ticket-print-area">
      <header class="ticket-header">
        <div class="operator-brand">
          <img *ngIf="getOperatorLogo(); else operatorInitials"
               [src]="getOperatorLogo()"
               [alt]="getOperatorName() + ' logo'">
          <ng-template #operatorInitials>
            <span class="operator-initials">{{ getOperatorInitials() }}</span>
          </ng-template>
          <div>
            <p class="eyebrow">E-ticket</p>
            <h1>{{ getReference() }}</h1>
            <span>{{ getOperatorName() }}</span>
          </div>
        </div>
        <span class="status-pill">{{ getPaymentStatus() }}</span>
      </header>

      <div class="ticket-body">
        <section class="ticket-main">
          <div class="ticket-route">
            <p>Trip</p>
            <h2>{{ getTripName() }}</h2>
            <div class="time-row">
              <span><i class="material-icons">schedule</i>{{ getDeparture() | date:'medium' }}</span>
              <span *ngIf="getArrival()"><i class="material-icons">flag</i>{{ getArrival() | date:'shortTime' }}</span>
            </div>
          </div>

          <dl>
            <div>
              <dt>Passenger</dt>
              <dd>{{ getPassenger() }}</dd>
            </div>
            <div>
              <dt>Contact</dt>
              <dd>{{ getContact() }}</dd>
            </div>
            <div>
              <dt>Seats</dt>
              <dd>{{ getSeats() }}</dd>
            </div>
            <div>
              <dt>Payment instruction</dt>
              <dd>{{ getPaymentStatus() }}</dd>
            </div>
          </dl>
        </section>

        <aside class="ticket-qr">
          <img *ngIf="getQrCodeUrl(); else qrFallback"
               class="qr-image"
               [src]="getQrCodeUrl()"
               alt="Ticket QR code">
          <ng-template #qrFallback>
            <div class="qr-fallback" aria-label="Ticket verification code">
              <span *ngFor="let cell of getQrCells()" [class.active]="cell"></span>
            </div>
          </ng-template>
          <p>Verification code</p>
          <strong>{{ getQrDisplayCode() }}</strong>
        </aside>
      </div>
    </article>
  </div>
</section>
